/* RESPONSIBLE TEAM: team-automation-foundations */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import type Router from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import { ReactRoute } from 'embercom/lib/react-route';

class FinAiAgentAllRolesRoute extends Route {
  @service declare appService: AppService;
  @service declare router: Router;

  reactEnabled() {
    return true;
  }

  beforeModel(transition: Transition) {
    if (!this.appService.app.canUseFeature('all-roles-page')) {
      transition.abort();
      this.router.transitionTo('apps.app.automation.fin-ai-agent.setup');
    }
  }
}

export default ReactRoute(FinAiAgentAllRolesRoute, {
  overrideRenderTemplate: false,
});
